module.exports = __webpack_public_path__ + "static/img/gongzhong-icon.6bad69f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gongzhong-icon.png
// module id = xXtl
// module chunks = 101